import { useTranslation } from 'react-i18next'
import { Text } from '@lounge-fe/ui-kit'
import { Money } from '@/components/Money'
import { BasketSummaryProps } from './types'
import { useShopify } from '@/hooks/useShopify'
import { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

const Row: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
}) => {
  return (
    <div className={twMerge('flex items-center justify-between', className)}>
      {children}
    </div>
  )
}

const BasketSummary: React.FC<BasketSummaryProps> = ({
  itemCount,
  itemsSubtotalPrice,
  totalPrice,
  totalDiscount,
}) => {
  const { t } = useTranslation()
  const { currency } = useShopify()

  return (
    <div className="bg-surface-secondary-default py-4 mx-4 px-4 2xl:mx-6 flex flex-col gap-y-2">
      <Row>
        <Text variant="body-sm" className="font-regular">
          {t('account.orders.order_summary')}:
        </Text>
        <Text variant="body-sm" className="font-regular">
          {itemCount} {t('general.item', { count: itemCount })}
        </Text>
      </Row>
      <hr />
      {itemsSubtotalPrice && itemsSubtotalPrice !== totalPrice && (
        <Row>
          <Text variant="body-sm">{t('cart.subtotal')}:</Text>
          <Money
            as={Text}
            variant="body-sm"
            data={{
              currencyCode: currency.active,
              amount: (itemsSubtotalPrice / 100).toString(),
            }}
          />
        </Row>
      )}
      {totalDiscount > 0 && (
        <Row>
          <Text variant="body-sm">{t('cart.discount')}:</Text>
          <Money
            as={Text}
            variant="body-sm"
            data={{
              currencyCode: currency.active,
              amount: ((totalDiscount / 100) * -1).toString(),
            }}
          />
        </Row>
      )}
      <Row>
        <Text variant="body-sm">{t('cart.total')}:</Text>
        <Money
          as={Text}
          variant="body-sm"
          data={{
            currencyCode: currency.active,
            amount: (totalPrice / 100).toString(),
          }}
        />
      </Row>
    </div>
  )
}

export { BasketSummary }
